/**
 * @generated SignedSource<<ff2db06015af3c945ad504b043eb37b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useEventLocationLabel_Event$data = {
  readonly courses: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly courseBucket: {
          readonly name: string;
        } | null | undefined;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly event: {
    readonly eventSeries: {
      readonly facility: {
        readonly " $fragmentSpreads": FragmentRefs<"useFacilityCourseNoun_facility">;
      };
    };
  };
  readonly " $fragmentType": "useEventLocationLabel_Event";
};
export type useEventLocationLabel_Event$key = {
  readonly " $data"?: useEventLocationLabel_Event$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEventLocationLabel_Event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useEventLocationLabel_Event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseConnection",
      "kind": "LinkedField",
      "name": "courses",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseBucket",
                  "kind": "LinkedField",
                  "name": "courseBucket",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSeries",
          "kind": "LinkedField",
          "name": "eventSeries",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useFacilityCourseNoun_facility"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventSession",
  "abstractKey": null
};
})();

(node as any).hash = "8dfe2a159f3b7f6c9e64883e3bcf47f6";

export default node;
